import request from '../request'

/**
 * 协同系统-项目执行-签章模板 相关接口
 */

/**
 * 新增签章模板
 * @param {Object} data - 签章模板数据
 */
export function addStampTemp(data) {
    return request({
        url: '/project-service/cosys/stampTemp/add',
        method: 'POST',
        data
    })
}

/**
 * 删除签章模板
 * @param {Object} data - 签章模板ID（或其他删除参数，按后端定义传参）
 */
export function deleteStampTemp(data) {
    return request({
        url: '/project-service/cosys/stampTemp/del',
        method: 'POST',
        data
    })
}

/**
 * 获取签章模板详情
 * @param {string|number} id - 签章模板ID
 */
export function fetchStampTempDetail(id) {
    return request({
        url: `/project-service/cosys/stampTemp/detail/${id}`,
        method: 'GET'
    })
}

/**
 * 获取签章模板列表
 * @param {Object} data - 查询参数（按后端定义传参）
 */
export function fetchStampTempList(data) {
    return request({
        url: '/project-service/cosys/stampTemp/list',
        method: 'POST',
        data
    })
}

/**
 * 修改签章模板
 * @param {Object} data - 签章模板数据
 */
export function updateStampTemp(data) {
    return request({
        url: '/project-service/cosys/stampTemp/update',
        method: 'POST',
        data
    })
}

// 如果你还需要保留原来的上传接口，可以继续用下面这个
/**
 * 上传签章文件
 * @param {string} stampType - 签章类型（路径参数）
 * @param {FormData} data - 文件数据
 */
export function uploadStampFile(stampType, data) {
    return request({
        url: `/project-service/project-service/cosys/stamp/${stampType}/upload`,
        method: 'POST',
        data
    })
}